import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
// import config from "../../../../config"; // Uncomment if needed
import { saveAs } from "file-saver";
import { formatarNumero } from "../../../../functions/formatarNumero";
import config from "../../../../config";

// =====================================================================
// HELPERS
// =====================================================================

// Helper to handle the "pagamentos" array from the JSON
export function getTiposPagamento(item) {
  // The JSON uses 'pagamentos', legacy might use 'formas_de_pagamento'
  const listaPagamentos = item.pagamentos || item.formas_de_pagamento;

  if (Array.isArray(listaPagamentos) && listaPagamentos.length > 0) {
    const tiposUnicos = [
      ...new Set(
        listaPagamentos
          .map((fp) => fp?.tipo)
          .filter(Boolean)
      ),
    ];
    return tiposUnicos.map((t) => t.toUpperCase()).join(" | ");
  }

  // Fallback for simple object legacy
  if (item?.forma_de_pagamento) {
    const mapa = {
      pix: "PIX",
      dinheiro: "DINHEIRO",
      cheque: "CHEQUE",
      outro: "OUTRO",
    };
    return mapa[item.forma_de_pagamento] || item.forma_de_pagamento.toUpperCase();
  }

  return "";
}

export function getValoresPagamentoPorTipo(item) {
  const listaPagamentos = item.pagamentos || item.formas_de_pagamento;

  if (Array.isArray(listaPagamentos) && listaPagamentos.length > 0) {
    const totalPorTipo = listaPagamentos.reduce((acc, fp) => {
      if (!fp?.tipo) return acc;
      const key = fp.tipo;
      const valor = Number(fp.valor || 0);
      acc[key] = (acc[key] || 0) + valor;
      return acc;
    }, {});

    return Object.entries(totalPorTipo)
      .map(
        ([tipo, valor]) => `${tipo.toUpperCase()}: ${formatarNumero(valor)}`
      )
      .join(" | ");
  }

  if (item?.forma_de_pagamento && item?.valor_recebido) {
    const label = getTiposPagamento(item);
    return `${label}: ${formatarNumero(item.valor_recebido)}`;
  }

  return "";
}


async function getRelatorioGeral(user, event_id, vendedor, tiposPagamentoSelecionados) {

  console.log(tiposPagamentoSelecionados)
  try {
    const response = await fetch(
      `${config.urlServer}/event/relatorios/relatorio-geral-pdf`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          email: user.email,
          token: user.token,
          eventid: event_id,
          vendedor,
          tiposPagamentoSelecionados
        },
      }
    );

    const responseData = await response.json();

    if (response.status !== 200) {
      const errorMessage =
        responseData.msg || "Erro desconhecido ao buscar os eventos";
      throw new Error({ message: errorMessage, status: response.status });
    }

    // console.log(responseData);

    let relatorio = `numero;status;vendedor;comprador;valor_total_locacao;valor_por_lugar;lugares;valor_recebido;forma_de_pagamento;\n`;

    if (responseData.locacoes) {
      for (let i = 0; i < responseData.locacoes.length; i++) {
        let element = responseData.locacoes[i];
        relatorio += `${element?.numero};${element?.status};${element?.vendedor};${element?.comprador};${element?.valor_total_locacao};${element?.valor_por_lugar};${element?.lugares.length};${element?.valor_recebido};${element?.forma_de_pagamento};\n`;
      }
    }
    // downloadJsonFile(responseData.locacoes, "relatorio_vendas.json");
    
    let locacoes = responseData.locacoes
    let ingressos_avulsos = responseData.ingressos_avulsos
    let list_transacoes = responseData.list_transacoes
    return {locacoes, ingressos_avulsos, list_transacoes};
    // return responseData;
  } catch (error) {
    console.error(error);
    throw new Error(
      error.message || "Ops, algo deu errado ao gerar relatório!"
    );
  }
}

// Function to fetch data (Mocked or Real)
// Assuming 'data' is passed directly to the generation function or fetched here
// For this example, we assume data is passed into the main function `relatorioGeralPdf`

// =====================================================================
// PDF GENERATION
// =====================================================================

export const relatorioGeralPdf = async (user, event_id, nomeEvento, vendedor="", tiposPagamentoSelecionados) => {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  // Use externalData if provided (the JSON), otherwise fallback or fetch
  // In your context, ensure you pass the JSON data into this function or fetch it here.
  const data = await getRelatorioGeral(user, event_id, vendedor, tiposPagamentoSelecionados); 
  
  // const data = externalData; 

  if (!data) {
    console.error("Dados não fornecidos para o PDF");
    return;
  }

  // Extract main sections from JSON
  const locacoesData = data.locacoes;
  const ingressosData = data.ingressos_avulsos;
  const list_transacoes = data.list_transacoes
  const reportTitle = [
    {
      text: "RELATÓRIO GERAL",
      fontSize: 12,
      bold: true,
      margin: [15, 20, 0, 45], // left, top, right, bottom
    },
  ];

  // -----------------------------------------------------------------
  // MAP LOCACOES LIST ROWS
  // -----------------------------------------------------------------
  const rowsLocacoes = (locacoesData?.lista || []).map((item) => {
    const tiposPagamento = getTiposPagamento(item);
    const valoresPorTipo = getValoresPagamentoPorTipo(item);
    
    // Status normalization
    let statusText = item?.status || "ERRO";
    if(statusText === 'vendido') statusText = 'Vendido';
    if(statusText === 'disponivel') statusText = 'Disponível';
    if(statusText === 'reservado') statusText = 'Reservado';

    // Payment Status normalization
    let pagamentoStatus = item?.pagamento || "Erro";
    if(pagamentoStatus === 'integral') pagamentoStatus = 'Pago';
    if(pagamentoStatus === 'parcial') pagamentoStatus = 'Parcial';
    if(pagamentoStatus === 'nenhum') pagamentoStatus = 'Pendente';

    return [
      { text: item?.mesa || item?.numero || "-", fontSize: 9, margin: [0, 1, 0, 1] },
      { text: statusText, fontSize: 9, margin: [0, 2, 0, 2] },
      { text: item?.vendedor_nome || "", fontSize: 9, margin: [0, 2, 0, 2] },
      { text: item?.comprador || "", fontSize: 9, margin: [0, 2, 0, 2] },
      // Payment Types
      { text: tiposPagamento, fontSize: 9, margin: [0, 1, 0, 1] },
      // Payment Values
      { text: valoresPorTipo, fontSize: 9, margin: [0, 1, 0, 1] },
      // Lugares Count
      { text: item.lugares ? item.lugares.length : 0, fontSize: 9, margin: [0, 1, 0, 1] },
      // Total Value
      { text: formatarNumero(item?.valor_total_locacao), fontSize: 9, margin: [0, 1, 0, 1] },
      // Received Value
      { text: formatarNumero(item?.valor_recebido), fontSize: 9, margin: [0, 1, 0, 1] },
      // Status
      { text: pagamentoStatus, fontSize: 9, margin: [0, 1, 0, 1] },
    ];
  });

  // -----------------------------------------------------------------
  // MAP INGRESSOS LIST ROWS
  // -----------------------------------------------------------------
  const rowsIngressos = (ingressosData?.lista || []).map((item) => {
    const tiposPagamento = getTiposPagamento(item);
    
    let statusText = item?.status || "ERRO";
    if(statusText === 'vendido') statusText = 'Vendido';
    if(statusText === 'disponivel') statusText = 'Disponível';
    if(statusText === 'reservado') statusText = 'Reservado';

    let pagamentoStatus = item?.pagamento || "Erro";
    if(pagamentoStatus === 'integral') pagamentoStatus = 'Pago';
    if(pagamentoStatus === 'parcial') pagamentoStatus = 'Parcial';
    if(pagamentoStatus === 'nenhum') pagamentoStatus = 'Pendente';

    return [
      { text: statusText, fontSize: 9, margin: [0, 2, 0, 2] },
      { text: item?.vendedor_nome || "", fontSize: 9, margin: [0, 2, 0, 2] },
      { text: item?.comprador || "", fontSize: 9, margin: [0, 2, 0, 2] },
      { text: tiposPagamento, fontSize: 9, margin: [0, 1, 0, 1] },
      { text: formatarNumero(item?.valor_total_locacao), fontSize: 9, margin: [0, 1, 0, 1] },
      { text: formatarNumero(item?.valor_recebido), fontSize: 9, margin: [0, 1, 0, 1] },
      { text: pagamentoStatus, fontSize: 9, margin: [0, 1, 0, 1] },
    ];
  });

    // -----------------------------------------------------------------
  // MAP TRANSACOES LIST ROWS
  // -----------------------------------------------------------------
  const rowsTransacoes = (list_transacoes || []).map((item) => {
    
      // { text: "DATA", style: "tableHeader", fontSize: 10, bold: true },
      //       { text: "VENDEDOR", style: "tableHeader", fontSize: 10, bold: true },
      //       { text: "COMPRADOR", style: "tableHeader", fontSize: 10, bold: true },
      //       { text: "FORMA DE PGTO", style: "tableHeader", fontSize: 10, bold: true },
      //       { text: "VALOR", style: "tableHeader", fontSize: 10, bold: true },

    return [
      { text: item.data_pagamento_, fontSize: 9, margin: [0, 2, 0, 2] },
      { text: item?.vendedor_nome || "", fontSize: 9, margin: [0, 2, 0, 2] },
      { text: item?.comprador || "", fontSize: 9, margin: [0, 2, 0, 2] },
      { text: item?.origem || "", fontSize: 9, margin: [0, 2, 0, 2] },
      { text: item?.tipo.toUpperCase(), fontSize: 9, margin: [0, 1, 0, 1] },
      { text: formatarNumero(item?.valor), fontSize: 9, margin: [0, 1, 0, 1] },
    ];
  });

  // Helper to extract nested values safely with 0 fallback
  const v = (val) => val || 0;
  const p = (val) => parseFloat(val || 0).toFixed(2) + "%";


  // =====================================================================
  // DOCUMENT CONTENT CONSTRUCTION
  // =====================================================================
  
  const content = [
    // -------------------------------------------------------
    // SEÇÃO 1: LOCAÇÕES - RESUMO
    // -------------------------------------------------------
    { text: "Locações/Mesas - Resumo:", style: "subheader" },
    {
      table: {
        headerRows: 1,
        widths: [120, 110, 110, 70, 70],
        body: [
          [
            { text: "Descrição", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Quantidade Locações", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Quantidade Lugares", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Porcentagem", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Valores Calculados", style: "tableHeader", fontSize: 9, bold: true },
          ],
          // Vendidos
          [
            { text: "Vendidos", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(locacoesData.vendidos.locacoes), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: v(locacoesData.vendidos.lugares), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p(locacoesData.vendidos.porcentagem_locacoes), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(locacoesData.vendidos.valor_calculado_total_locacao), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Reservados
          [
            { text: "Reservados", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(locacoesData.reservados.locacoes), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: v(locacoesData.reservados.lugares), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p(locacoesData.reservados.porcentagem_locacoes), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(locacoesData.reservados.valor_calculado_total_locacao), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Disponível
          [
            { text: "Disponível", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(locacoesData.disponivel.locacoes), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: v(locacoesData.disponivel.lugares), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p(locacoesData.disponivel.porcentagem_locacoes), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(locacoesData.disponivel.valor_calculado_total_locacao), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Total
          [
            { text: "TOTAL", fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] },
            { text: v(locacoesData.total.locacoes), fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 1, 0, 1] },
            { text: v(locacoesData.total.lugares), fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 1, 0, 1] },
            { text: "100.00%", fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] },
            { text: formatarNumero(locacoesData.total.valor_calculado_total_locacao), fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] },
          ],
        ],
      },
      style: "tableExample",
      marginBottom: 5,
    },

    // -------------------------------------------------------
    // SEÇÃO 2: LOCAÇÕES - RECEBIMENTOS
    // -------------------------------------------------------
    { text: "Locações/Mesas - Resumo dos recebimentos (Vendidos):", style: "subheader" },
    {
      table: {
        headerRows: 1,
        widths: [120, 120, 70, 70],
        body: [
          [
            { text: "Descrição", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Quantidade", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Porcentagem (Qtd)", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Valor Recebido", style: "tableHeader", fontSize: 9, bold: true },
          ],
          // Integral
          [
            { text: "Recebido integral", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(locacoesData.vendidos.recebimentos.integral.quantidade), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p((v(locacoesData.vendidos.recebimentos.integral.quantidade) / v(locacoesData.vendidos.locacoes)) * 100), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(locacoesData.vendidos.recebimentos.integral.valor.recebido), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Parcial
          [
            { text: "Recebido parcial", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(locacoesData.vendidos.recebimentos.parcial.quantidade), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p((v(locacoesData.vendidos.recebimentos.parcial.quantidade) / v(locacoesData.vendidos.locacoes)) * 100), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(locacoesData.vendidos.recebimentos.parcial.valor.recebido), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Nenhum
          [
            { text: "Nenhum valor recebido", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(locacoesData.vendidos.recebimentos.nenhum.quantidade), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p((v(locacoesData.vendidos.recebimentos.nenhum.quantidade) / v(locacoesData.vendidos.locacoes)) * 100), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(locacoesData.vendidos.recebimentos.nenhum.valor.recebido), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Total Recebido
          [
            { text: "TOTAL RECEBIDO (Soma)", fontSize: 7, bold: true, fillColor: "#eeeeff", colSpan: 3, margin: [0, 2, 0, 2] },
            {}, {},
            { text: formatarNumero(locacoesData.vendidos.valor_recebido), fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] },
          ],
        ],
      },
      style: "tableExample",
      marginBottom: 5,
    },

    // -------------------------------------------------------
    // SEÇÃO 3: LOCAÇÕES - MEIOS DE PAGAMENTO
    // -------------------------------------------------------
    { text: "Locações/Mesas - Meios de recebimentos (Vendidos):", style: "subheader" },
    {
      table: {
        headerRows: 1,
        widths: [120, 120, 70, 70],
        body: [
          [
            { text: "Descrição", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Quantidade", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Valor", style: "tableHeader", fontSize: 9, bold: true },
            { text: "", style: "tableHeader", fontSize: 9, bold: true },
          ],
          // Rows based on JSON keys inside 'meios_de_pagamento'
          ...Object.entries(locacoesData.vendidos.meios_de_pagamento).map(([key, data]) => {
             return [
                { text: key.toUpperCase(), fontSize: 7, margin: [0, 2, 0, 2] },
                { text: v(data.quantidade), fontSize: 7, margin: [0, 1, 0, 1] },
                { text: formatarNumero(data.valor), fontSize: 7, margin: [0, 2, 0, 2] },
                { text: "", fontSize: 7 },
             ];
          }),
          // Total Row
          [
             { text: "TOTAL", fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] },
             { 
               text: Object.values(locacoesData.vendidos.meios_de_pagamento).reduce((a, b) => a + (b.quantidade || 0), 0), 
               fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 1, 0, 1] 
             },
             { 
               text: formatarNumero(Object.values(locacoesData.vendidos.meios_de_pagamento).reduce((a, b) => a + (b.valor || 0), 0)), 
               fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] 
             },
             { text: "", fillColor: "#eeeeff" }
          ]
        ],
      },
      style: "tableExample",
      marginBottom: 5,
    },

    // Separator
    { text: "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------", fontSize: 4, margin: [0, 0, 0, 10] },
    { text: "", pageBreak: "before" },

    // -------------------------------------------------------
    // SEÇÃO 4: INGRESSOS - RESUMO
    // -------------------------------------------------------
    { text: "Ingressos Avulsos - Resumo:", style: "subheader" },
    {
      table: {
        headerRows: 1,
        widths: [120, 110, 70, 70],
        body: [
          [
            { text: "Descrição", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Quantidade", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Porcentagem", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Valores Calculados", style: "tableHeader", fontSize: 9, bold: true },
          ],
          // Vendidos
          [
            { text: "Vendidos", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(ingressosData.vendidos.locacoes), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p(ingressosData.vendidos.porcentagem_locacoes), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(ingressosData.vendidos.valor_calculado_total_locacao), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Reservados
          [
            { text: "Reservados", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(ingressosData.reservados.locacoes), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p(ingressosData.reservados.porcentagem_locacoes), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(ingressosData.reservados.valor_calculado_total_locacao), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Disponível
          [
            { text: "Disponível", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(ingressosData.disponivel.locacoes), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p(ingressosData.disponivel.porcentagem_locacoes), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(ingressosData.disponivel.valor_calculado_total_locacao), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Total
          [
            { text: "TOTAL", fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] },
            { text: v(ingressosData.total.locacoes), fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 1, 0, 1] },
            { text: "100.00%", fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] },
            { text: formatarNumero(ingressosData.total.valor_calculado_total_locacao), fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] },
          ],
        ],
      },
      style: "tableExample",
      marginBottom: 5,
    },

    // -------------------------------------------------------
    // SEÇÃO 5: INGRESSOS - RECEBIMENTOS
    // -------------------------------------------------------
    { text: "Ingressos Avulsos - Resumo dos recebimentos (Vendidos):", style: "subheader" },
    {
      table: {
        headerRows: 1,
        widths: [120, 120, 70, 70],
        body: [
          [
            { text: "Descrição", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Quantidade", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Porcentagem (Qtd)", style: "tableHeader", fontSize: 9, bold: true },
            { text: "Valor Recebido", style: "tableHeader", fontSize: 9, bold: true },
          ],
          // Integral
          [
            { text: "Recebido integral", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(ingressosData.vendidos.recebimentos.integral.quantidade), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p((v(ingressosData.vendidos.recebimentos.integral.quantidade) / v(ingressosData.vendidos.locacoes)) * 100), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(ingressosData.vendidos.recebimentos.integral.valor.recebido), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Parcial
          [
            { text: "Recebido parcial", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(ingressosData.vendidos.recebimentos.parcial.quantidade), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p((v(ingressosData.vendidos.recebimentos.parcial.quantidade) / v(ingressosData.vendidos.locacoes)) * 100), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(ingressosData.vendidos.recebimentos.parcial.valor.recebido), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
          // Nenhum
          [
            { text: "Nenhum valor recebido", fontSize: 7, margin: [0, 2, 0, 2] },
            { text: v(ingressosData.vendidos.recebimentos.nenhum.quantidade), fontSize: 7, margin: [0, 1, 0, 1] },
            { text: p((v(ingressosData.vendidos.recebimentos.nenhum.quantidade) / v(ingressosData.vendidos.locacoes)) * 100), fontSize: 7, margin: [0, 2, 0, 2] },
            { text: formatarNumero(ingressosData.vendidos.recebimentos.nenhum.valor.recebido), fontSize: 7, margin: [0, 2, 0, 2] },
          ],
           // Total Recebido
           [
            { text: "TOTAL RECEBIDO (Soma)", fontSize: 7, bold: true, fillColor: "#eeeeff", colSpan: 3, margin: [0, 2, 0, 2] },
            {}, {},
            { text: formatarNumero(ingressosData.vendidos.valor_recebido), fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] },
          ],
        ],
      },
      style: "tableExample",
      marginBottom: 5,
    },

    // -------------------------------------------------------
    // SEÇÃO 6: INGRESSOS - MEIOS DE PAGAMENTO
    // -------------------------------------------------------
    { text: "Ingressos Avulsos - Meios de recebimentos (Vendidos):", style: "subheader" },
    {
        table: {
          headerRows: 1,
          widths: [120, 120, 70, 70],
          body: [
            [
              { text: "Descrição", style: "tableHeader", fontSize: 9, bold: true },
              { text: "Quantidade", style: "tableHeader", fontSize: 9, bold: true },
              { text: "Valor", style: "tableHeader", fontSize: 9, bold: true },
              { text: "", style: "tableHeader", fontSize: 9, bold: true },
            ],
            // Rows based on JSON keys inside 'meios_de_pagamento'
            ...Object.entries(ingressosData.vendidos.meios_de_pagamento).map(([key, data]) => {
               return [
                  { text: key.toUpperCase(), fontSize: 7, margin: [0, 2, 0, 2] },
                  { text: v(data.quantidade), fontSize: 7, margin: [0, 1, 0, 1] },
                  { text: formatarNumero(data.valor), fontSize: 7, margin: [0, 2, 0, 2] },
                  { text: "", fontSize: 7 },
               ];
            }),
             // Total Row
             [
                { text: "TOTAL", fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] },
                { 
                  text: Object.values(ingressosData.vendidos.meios_de_pagamento).reduce((a, b) => a + (b.quantidade || 0), 0), 
                  fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 1, 0, 1] 
                },
                { 
                  text: formatarNumero(Object.values(ingressosData.vendidos.meios_de_pagamento).reduce((a, b) => a + (b.valor || 0), 0)), 
                  fontSize: 7, bold: true, fillColor: "#eeeeff", margin: [0, 2, 0, 2] 
                },
                { text: "", fillColor: "#eeeeff" }
             ]
          ],
        },
        style: "tableExample",
        marginBottom: 5,
    },

    // -------------------------------------------------------
    // SEÇÃO 7: LISTAGEM DETALHADA - LOCAÇÕES
    // -------------------------------------------------------
    { text: "", pageBreak: "before" },
    { text: "Lista Detalhada: Locações/Mesas", style: "subheader" },
    {
      table: {
        headerRows: 1,
        widths: [45, 45, 110,110, 60, 80, 45, 50, 50, 65],
        body: [
          [
            { text: "MESA", style: "tableHeader", fontSize: 10, bold: true },
            { text: "STATUS", style: "tableHeader", fontSize: 10, bold: true },
            { text: "VENDEDOR", style: "tableHeader", fontSize: 10, bold: true },
            { text: "COMPRADOR", style: "tableHeader", fontSize: 10, bold: true },
            { text: "TIPOS PGTO", style: "tableHeader", fontSize: 10, bold: true },
            { text: "VALORES PGTO", style: "tableHeader", fontSize: 10, bold: true },
            { text: "LUG.", style: "tableHeader", fontSize: 10, bold: true },
            { text: "V. TOTAL", style: "tableHeader", fontSize: 10, bold: true },
            { text: "V. REC.", style: "tableHeader", fontSize: 10, bold: true },
            { text: "PAGAMENTO", style: "tableHeader", fontSize: 10, bold: true },
          ],
          ...rowsLocacoes,
        ],
      },
      layout: {
        fillColor: function (rowIndex) {
          return rowIndex % 2 === 0 ? "#ddd" : null;
        },
      },
    },

    // -------------------------------------------------------
    // SEÇÃO 8: LISTAGEM DETALHADA - INGRESSOS
    // -------------------------------------------------------
    { text: "", pageBreak: "before" },
    { text: "Lista Detalhada: Ingressos Avulsos", style: "subheader" },
    {
      table: {
        headerRows: 1,
        widths: [60, 140, 140, 52, 50, 50, 70],
        body: [
          [
            { text: "STATUS", style: "tableHeader", fontSize: 10, bold: true },
            { text: "VENDEDOR", style: "tableHeader", fontSize: 10, bold: true },
            { text: "COMPRADOR", style: "tableHeader", fontSize: 10, bold: true },
            { text: "FORMA DE PGTO", style: "tableHeader", fontSize: 10, bold: true },
            { text: "V. TOTAL", style: "tableHeader", fontSize: 10, bold: true },
            { text: "V. REC.", style: "tableHeader", fontSize: 10, bold: true },
            { text: "PAGAMENTO", style: "tableHeader", fontSize: 10, bold: true },
          ],
          ...rowsIngressos,
        ],
      },
      layout: {
        fillColor: function (rowIndex) {
          return rowIndex % 2 === 0 ? "#ddd" : null;
        },
      },
    },


        // -------------------------------------------------------
    // SEÇÃO 8: TRANSAÇÕES
    // -------------------------------------------------------
    { text: "", pageBreak: "before" },
    { text: "Listagem de transações", style: "subheader" },
    {
      table: {
        headerRows: 1,
        widths: [60, 140, 140, 100, 52, 50, 70, 70],
        body: [
          [
            { text: "DATA", style: "tableHeader", fontSize: 10, bold: true },
            { text: "VENDEDOR", style: "tableHeader", fontSize: 10, bold: true },
            { text: "COMPRADOR", style: "tableHeader", fontSize: 10, bold: true },
            { text: "ORIGEM", style: "tableHeader", fontSize: 10, bold: true },
            { text: "FORMA DE PGTO", style: "tableHeader", fontSize: 10, bold: true },
            { text: "VALOR", style: "tableHeader", fontSize: 10, bold: true },
            ],
          ...rowsTransacoes,
        ],
      },
      layout: {
        fillColor: function (rowIndex) {
          return rowIndex % 2 === 0 ? "#ddd" : null;
        },
      },
    },
  ];

  function Rodape(currentPage, pageCount) {
    return [
      {
        text: currentPage + " / " + pageCount,
        alignment: "right",
        fontSize: 9,
        margin: [0, 10, 20, 0], // left, top, right, bottom
      },
    ];
  }

  const docDefinitions = {
    pageSize: "A4",
    pageOrientation: "landscape",
    pageMargins: [15, 35, 35, 20],
    header: reportTitle,
    content: content,
    footer: Rodape,
    styles: {
      subheader: {
        fontSize: 10,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black'
      },
      tableExample: {
        margin: [0, 5, 0, 15]
      }
    }
  };

  // Crie o PDF
  const pdfDocGenerator = pdfMake.createPdf(docDefinitions);

  // Gere um Blob a partir do PDF
  pdfDocGenerator.getBlob((blob) => {
    // Crie um link temporário
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Relatório Geral - ${nomeEvento || ""}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};